<template>
    <div>
        <div class="autoOpenContent" v-if="generalSettings.configAbility.indexOf(1) > -1">
            <div class="autoOpenTop">
                <div class="panelsItem" v-show="generalSettings.carPlateRecognitionEnable === 1">
                    <label :title="$t('WiegandInput')">{{$t('WiegandInput')}}</label>
                    <el-select v-model="generalSettings.wiegandInputType" class="editInput" :placeholder="$t('WiegandInput')">
                        <el-option
                        v-for="item in generalSettings.wiegandInputTypeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="panelsItem" v-show="generalSettings.materCodeEnable === 1">
                    <label :title="$t('MasterCode')">{{$t('MasterCode')}}</label>
                    <!-- <el-input class="editInput" v-model="generalSettings.materCode"></el-input> -->
                     <el-input class="editInput" v-model="generalSettings.materCode" :type="generalSettings.passwordFlage" :placeholder="$t('MasterCode')" auto-complete="new-password">
                        <i slot="suffix" class="el-input__icon" @click="changeMaterCodeasswordShow">
                            <img style="width: 20px;margin-top: 10px; margin-right: 10px;" :src="generalSettings.passwordImg" alt="">
                        </i>
                    </el-input>
                </div>
                <div class="panelsItem" v-show="generalSettings.relayActivationTimeEnable === 1">
                    <label :title="$t('RelayActivationTime')">{{$t('RelayActivationTime')}}</label>
                    <el-input class="editInput" v-model="generalSettings.relayActivationTime"></el-input>
                </div>
                <div class="panelsItem" v-show="generalSettings.buttonBeepEnable === 1">
                    <label :title="$t('ButtonBeep')">{{$t('ButtonBeep')}}</label>
                    <el-select v-model="generalSettings.buttonBeep" class="editInput" :placeholder="$t('ButtonBeep')">
                        <el-option
                        v-for="item in generalSettings.buttonBeepOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="panelsItem" v-show="generalSettings.exitButtonUnlockTimeEnable === 1">
                    <label :title="$t('ExitButtonUnlockTime')">{{$t('ExitButtonUnlockTime')}}</label>
                    <el-select v-model="generalSettings.exitButtonUnlockTime" class="editInput" :placeholder="$t('ExitButtonUnlockTime')">
                        <el-option
                        v-for="item in generalSettings.exitButtonUnlockTimeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="panelsItem" v-show="generalSettings.toneVolumeEnable === 1">
                    <label :title="$t('ToneVolume')">{{$t('ToneVolume')}}</label>
                    <el-select v-model="generalSettings.toneVolume" class="editInput" :placeholder="$t('ToneVolume')">
                        <el-option
                        v-for="item in generalSettings.toneVolumeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="panelsItem" v-show="generalSettings.tamperAlarmEnable === 1">
                    <label :title="$t('TamperAlarm')">{{$t('TamperAlarm')}}</label>
                    <el-select v-model="generalSettings.tamperAlarm" class="editInput" :placeholder="$t('TamperAlarm')">
                        <el-option
                        v-for="item in generalSettings.tamperAlarmOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="panelsItem" v-show="generalSettings.pwdErrorProtectionEnable === 1">
                    <label :title="$t('ContinuousInputErrorProtection')">{{$t('ContinuousInputErrorProtection')}}</label>
                    <el-select v-model="generalSettings.pwdErrorProtection" class="editInput" :placeholder="$t('ContinuousInputErrorProtection')">
                        <el-option
                        v-for="item in generalSettings.pwdErrorProtectionOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="panelsItem" v-show="generalSettings.timezoneEnable === 1">
                    <label :title="$t('TimeZone')">{{$t('TimeZone')}}</label>
                    <el-select v-model="generalSettings.timeZone" class="editInput" :placeholder="$t('TimeZone')">
                        <el-option
                        v-for="item in generalSettings.timeZoneOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            
            <div class="bottomDiv">
                <el-button class="savetBtn" :loading="this.generalSettings.updateAutoOpenState == 1" @click="applyGeneralConfig">{{$t('Apply')}}</el-button>
            </div>
        </div>
        <div v-else>
            <h3>{{$t('DeviceNotSupportConfig')}}</h3>
        </div>
    </div>
    
  
</template>

<script>
import { mapState } from 'vuex';
import sitesPanelsApi from '@/api/panels/index.js'
import showPassword from '@/assets/images/password_show.png'
import hidePassword from '@/assets/images/password_hide.png'
export default {
    name:"GeneralSettings",
    data(){
        return{
            generalSettings:{
                configAbility:[], //能力及支持项
                carPlateRecognitionEnable:0,
                wiegandInputType:0,
                wiegandInputTypeOptions:[
                    {
                        id:0,
                        name:this.$t('RFID')
                    },
                    {
                        id:1,
                        name:this.$t('CarPlate')
                    },
                ],
                passwordFlage:"password",
                passwordImg:hidePassword,
                showPassword,
                hidePassword,
                materCodeEnable:0,
                materCode:'',
                relayActivationTimeEnable:0,
                relayActivationTime:"2",
                buttonBeepEnable:0,
                buttonBeep:null,
                buttonBeepOptions:[
                    {
                        id:"1",
                        name:this.$t('ON')
                    },
                    {
                        id:"2",
                        name:this.$t('OFF')
                    },
                ],
                exitButtonUnlockTimeEnable:0,
                exitButtonUnlockTime:"3",
                exitButtonUnlockTimeOptions:[],
                toneVolumeEnable:0,
                toneVolume:"2",
                toneVolumeOptions:[
                     {
                        id:"1",
                        name:"1"
                    },
                    {
                        id:"2",
                        name:"2"
                    },
                    {
                        id:"3",
                        name:"3"
                    },
                ],
                tamperAlarmEnable:0,
                tamperAlarm:"2",
                tamperAlarmOptions:[
                    {
                        id:"1",
                        name:this.$t('ON')
                    },
                    {
                        id:"2",
                        name:this.$t('OFF')
                    },
                ],
                pwdErrorProtectionEnable:0,
                pwdErrorProtection:"1",
                pwdErrorProtectionOptions:[
                    {
                        id:"1",
                        name:this.$t('ON')
                    },
                    {
                        id:"2",
                        name:this.$t('OFF')
                    },
                ],
                timeZoneOptionsAll:[
                    {
                        id:0,
                        name:"GMT00 London,Lisbon,Dublin"
                    },
                    {
                        id:1,
                        name:"GMT+1 Rome,Paris,Berlin"
                    },
                    {
                        id:2,
                        name:"GMT+2 Athens,Istanbul,Bucharest"
                    },
                    {
                        id:3,
                        name:"GMT+3 Moscow,Mogadishu,Doha"
                    },
                    {
                        id:4,
                        name:"GMT+3:30 Tehran"
                    },
                    {
                        id:5,
                        name:"GMT+4 Abu Dhabi,Dubai,Port Louis"
                    },
                    {
                        id:6,
                        name:"GMT+4:30 Kabul"
                    },
                    {
                        id:7,
                        name:"GMT+5 Karachi"
                    },
                    {
                        id:8,
                        name:"GMT+5:30 New Delhi,Kolkata,Colombo"
                    },
                    {
                        id:9,
                        name:"GMT+6 Almaty,Decca"
                    },
                    {
                        id:10,
                        name:"GMT+7 Bangkok,Jakarta,Hanoi"
                    },
                    {
                        id:11,
                        name:"GMT+8 Hong Kong,Beijing,Singapore"
                    },
                    {
                        id:12,
                        name:"GMT+9 Osaka,Tokyo,Seoul"
                    },
                    {
                        id:13,
                        name:"GMT+9:30 Darwin"
                    },
                    {
                        id:14,
                        name:"GMT+10 Brisbane"
                    },
                    {
                        id:15,
                        name:"GMT+11 Kolonia,Noumea,Honiara"
                    },
                    {
                        id:16,
                        name:"GMT+12 Auckland,Auckland,Fiji"
                    },
                    {
                        id:17,
                        name:"GMT-1 Ponta Delgada,Praia"
                    },
                    {
                        id:18,
                        name:"GMT-2 Sao Paulo,Rio de Janero,Brasilia"
                    },
                    {
                        id:19,
                        name:"GMT-3 Buenos Aires,Santigo,Nuuk"
                    },
                    {
                        id:20,
                        name:"GMT-4 Caracas,Georgetown"
                    },
                    {
                        id:21,
                        name:"GMT-5 Bogota,Boston,Lima"
                    },
                    {
                        id:22,
                        name:"GMT-6 Chicago,Dallas,Guatemala"
                    },
                    {
                        id:23,
                        name:"GMT-7 Phoenix,Denver,Edmonton"
                    },
                    {
                        id:24,
                        name:"GMT-8 Sacramento,Olympia,Vancouver"
                    },
                    {
                        id:25,
                        name:"GMT-9 Juneau"
                    },
                    {
                        id:26,
                        name:"GMT-10 Honolulu,Parapet"
                    },
                    {
                        id:27,
                        name:"GMT-11 Pago Pago"
                    },
                    {
                        id:28,
                        name:"GMT00 Antarctica,Troll"
                    },
                    {
                        id:29,
                        name:"GMT00 National Park (east coast)"
                    },
                    {
                        id:30,
                        name:"GMT+1 Dem. Rep. of Congo (west)"
                    },
                    {
                        id:31,
                        name:"GMT+2 Lubumbashi,Gaborone,Bujumbura"
                    },
                    {
                        id:32,
                        name:"GMT+05:45 Kathmandu"
                    },
                    {
                        id:33,
                        name:"GMT+6:30 Cocos,Yangon"
                    },
                    {
                        id:34,
                        name:"GMT+8:45 Western Australia (Eucla)"
                    },
                    {
                        id:35,
                        name:"GMT+9:30 New South Wales"
                    },
                    {
                        id:36,
                        name:"GMT+10 Macquarie Island,Melbourne"
                    },
                    {
                        id:37,
                        name:"GMT+10:30 Lord Howe Island"
                    },
                    {
                        id:38,
                        name:"GMT+11 Norfolk"
                    },
                    {
                        id:39,
                        name:"GMT+12 New Zealand, South Pole"
                    },
                    {
                        id:40,
                        name:"GMT+12:45 Chatham Islands"
                    },
                    {
                        id:41,
                        name:"GMT+13 Phoenix Islands,Fakaofo"
                    },
                    {
                        id:42,
                        name:"GMT+14 Line Islands"
                    },
                    {
                        id:43,
                        name:"GMT-1 Azores"
                    },
                    {
                        id:44,
                        name:"GMT-2 Atlantic islands"
                    },
                    {
                        id:45,
                        name:"GMT-3 Miquelon"
                    },
                    {
                        id:46,
                        name:"GMT-3:30 Newfoundland, Labrador (SE)"
                    },
                    {
                        id:47,
                        name:"GMT-4 Bermuda,Atlantic,most of Chile"
                    },
                    {
                        id:48,
                        name:"GMT-5 New York,Eastern (most areas)"
                    },
                    {
                        id:49,
                        name:"GMT-6 Central Mexico,CST - SK"
                    },
                    {
                        id:50,
                        name:"GMT-7 Creston,Dawson Cr,Ft St John"
                    },
                    {
                        id:51,
                        name:"GMT-8 Pitcairn"
                    },
                    {
                        id:52,
                        name:"GMT-9 Gambier Islands"
                    },
                    {
                        id:53,
                        name:"GMT-9:30 Marquesas Islands"
                    },
                    {
                        id:54,
                        name:"GMT-10 Alaska - western Aleutians"
                    },
                ],
                timezoneEnable:0,
                timeZone:'',
                timeZoneOptions:[],
                updateAutoOpenState:0,
            },
            updatePanels:{
                id:"",
            },
        }
    },
    mounted(){
       this.updatePanels.id = this.$route.params.id;
    //    this.getGeneralConfig();
    },
    computed:{
        ...mapState(["selectCompany","selectSite"])
    },
    methods:{
        //点击aterCode显示隐藏密码执行函数
        changeMaterCodeasswordShow(){
            if(this.generalSettings.passwordImg === this.generalSettings.showPassword){
                this.generalSettings.passwordImg = this.generalSettings.hidePassword;
                this.generalSettings.passwordFlage = "password";
            }else{
                this.generalSettings.passwordImg = this.generalSettings.showPassword;
                this.generalSettings.passwordFlage = "text";
            }
        },
        //查询General Settings配置
        getGeneralConfig(){
            let generalInfoObj = {
                "rgn":this.selectCompany.companyRegion,
                "entranceDeviceId":this.updatePanels.id,
                "siteId":this.selectSite.id,
                "filter":['wiegandInputType','materCode','relayActivationTime','buttonBeep','exitButtonUnlockTime','toneVolume','tamperAlarm','pwdErrorProtection','timezone'].join(','),
            }
            if(!this.updatePanels.id){
                return false
            }
            sitesPanelsApi.getGeneralDeviceShadowConfig(generalInfoObj).then(res => {
                if(res.code === 0){
                    //获取是否支持车牌设置
                    this.generalSettings.carPlateRecognitionEnable = res.data.configAbility.carPlateRecognitionEnable;
                    this.generalSettings.configAbility.push(res.data.configAbility.carPlateRecognitionEnable);
                    this.generalSettings.wiegandInputType = res.data.wiegandInputType;
                    //获取是否支工程密码
                    this.generalSettings.materCodeEnable = res.data.configAbility.materCodeEnable;
                    this.generalSettings.configAbility.push(res.data.configAbility.materCodeEnable);
                    this.generalSettings.materCode = res.data.materCode;
                    //获取是否支继电器开锁时长
                    this.generalSettings.relayActivationTimeEnable = res.data.configAbility.relayActivationTimeEnable;
                    this.generalSettings.configAbility.push(res.data.configAbility.relayActivationTimeEnable);
                    this.generalSettings.relayActivationTime = res.data.relayActivationTime;
                    //获取是否支按键提示音
                    this.generalSettings.buttonBeepEnable = res.data.configAbility.buttonBeepEnable;
                    this.generalSettings.configAbility.push(res.data.configAbility.buttonBeepEnable);
                    this.generalSettings.buttonBeep = res.data.buttonBeep;
                    //获取是否支开锁时长
                    this.generalSettings.exitButtonUnlockTimeEnable = res.data.configAbility.exitButtonUnlockTimeEnable;
                    this.generalSettings.exitButtonUnlockTimeOptions = [];
                    for(let i=0;i< 20; i++){
                        this.generalSettings.exitButtonUnlockTimeOptions.push({
                            id:i+"",
                            name: ((i+1) * 0.5).toFixed(1) + 's'
                        });
                    }
                    this.generalSettings.exitButtonUnlockTime = res.data.exitButtonUnlockTime;
                    //获取是否支提示音设置
                    this.generalSettings.toneVolumeEnable = res.data.configAbility.toneVolumeEnable;
                    this.generalSettings.configAbility.push(res.data.configAbility.toneVolumeEnable);
                    this.generalSettings.toneVolume = res.data.toneVolume;
                    //获取是否支防拆报警
                    this.generalSettings.tamperAlarmEnable = res.data.configAbility.tamperAlarmEnable;
                    this.generalSettings.configAbility.push(res.data.configAbility.tamperAlarmEnable);
                    this.generalSettings.tamperAlarm = res.data.tamperAlarm;
                    //获取是否支持连续输错保护
                    this.generalSettings.pwdErrorProtectionEnable = res.data.configAbility.pwdErrorProtectionEnable;
                    this.generalSettings.configAbility.push(res.data.configAbility.pwdErrorProtectionEnable);
                    this.generalSettings.pwdErrorProtection = res.data.pwdErrorProtection;
                    //获取是否支持时区
                    this.generalSettings.timezoneEnable = res.data.configAbility.timezoneEnable;
                    this.generalSettings.configAbility.push(res.data.configAbility.timezoneEnable);
                    //获取支持的时区
                    let timezoneEnums = res.data.configAbility.timezoneEnums;
                    this.generalSettings.timeZoneOptions = [];
                    if(timezoneEnums){
                        this.generalSettings.timeZoneOptionsAll.map(item => {
                            timezoneEnums.split(',').map(item2 => {
                                if(Number(item2) === item.id){
                                    this.generalSettings.timeZoneOptions.push(item);
                                }
                            })
                        })
                    }
                    //获取选中的时区
                    this.generalSettings.timeZone = res.data.timezone;
                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        applyGeneralConfig(){
            if(this.generalSettings.materCodeEnable === 1){
                let checkMaterCodeRegex = /^\d{6,12}$/;
                if(!checkMaterCodeRegex.test(this.generalSettings.materCode)){
                    this.$message.info(this.$t('MaterCodeLimit'));
                    return false
                }
            }
            if(this.generalSettings.relayActivationTimeEnable === 1){
                let checkRelayAcTRegex = /^[1-9][0-9]?$/;
                if(!checkRelayAcTRegex.test(this.generalSettings.relayActivationTime)){
                    this.$message.info(this.$t('RelayActivationTimeLimit'));
                    return false
                }
            }
            
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let generalConfigObj = {
                "entranceDeviceId": this.updatePanels.id,
                "siteId":this.selectSite.id,
                // "wiegandInputType":this.generalSettings.wiegandInputType,
            };
            if(this.generalSettings.carPlateRecognitionEnable === 1){
                generalConfigObj.wiegandInputType = this.generalSettings.wiegandInputType;
            }
            if(this.generalSettings.materCodeEnable === 1){
                generalConfigObj.materCode = this.generalSettings.materCode;
            }
            if(this.generalSettings.relayActivationTimeEnable === 1){
                generalConfigObj.relayActivationTime = this.generalSettings.relayActivationTime;
            }
            if(this.generalSettings.buttonBeepEnable === 1){
                generalConfigObj.buttonBeep = this.generalSettings.buttonBeep;
            }
            if(this.generalSettings.exitButtonUnlockTimeEnable === 1){
                generalConfigObj.exitButtonUnlockTime = this.generalSettings.exitButtonUnlockTime;
            }
            if(this.generalSettings.toneVolumeEnable === 1){
                generalConfigObj.toneVolume = this.generalSettings.toneVolume;
            }
            if(this.generalSettings.tamperAlarmEnable === 1){
                generalConfigObj.tamperAlarm = this.generalSettings.tamperAlarm;
            }
            if(this.generalSettings.pwdErrorProtectionEnable === 1){
                generalConfigObj.pwdErrorProtection = this.generalSettings.pwdErrorProtection;
            }
            if(this.generalSettings.timezoneEnable === 1){
                generalConfigObj.timezone = this.generalSettings.timeZone;
            }
            console.log("generalConfigObj",generalConfigObj);
            // return false
            this.generalSettings.updateAutoOpenState = 1;
            sitesPanelsApi.saveGeneralDeviceShadowConfig(rgnObj,generalConfigObj).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('ApplicationSuccessful'));
                    this.generalSettings.updateAutoOpenState = 0;
                    //获取GeneralConfig Settings 配置
                    this.getGeneralConfig();
                }else{
                    this.generalSettings.updateAutoOpenState = 0;
                    this.$handerrcode(res.code);
                    //获取GeneralConfig Settings 配置
                    this.getGeneralConfig();
                }
            }).catch((err) => {
                console.log(err);
                this.generalSettings.updateAutoOpenState = 0;
            })
        }
    },
    
}
</script>

<style scoped>
.autoOpenTop{
    text-align: left;
}
.panelsItem{
    display: flex;
    align-items: baseline;
    margin-top: 10px;
}
.panelsItem label{
    width: 200px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: inherit;
    line-height: 1.5;
}
.panelsItem input{
    width: 300px;
}
/* .autoOpenCenter{
    padding: 5px 25px 20px;
    width: 320px;
    margin-top: 20px;
    background: #F4F4F4;
    border-radius: 8px;
}
.autoOpenCenter .panelsItem{
    margin-top: 0;
} */
.editInput{
    width: 300px;
}
::v-deep .editInput .el-input__inner {
    height: 39px!important;
    line-height: 39px!important;
    border: 1px solid #333;
    background: #fff;
}
::v-deep .editInput .el-input__inner:hover {
    height: 39px!important;
    line-height: 39px!important;
    border: 1px solid #333;
    background: #fff;
}
::v-deep .timePicker .el-input__inner{
    height: 35px;
    line-height: 35px;
    background: #fff;
    text-align: center;
}
/* ::v-deep .autoOpenCenter .panelsItem .el-input__icon{
    line-height: 35px;
} */
/* ::v-deep .timePicker input::placeholder{
   font-size: 12px !important;
} */
/* input::placeholder {
  font-size: 14px;
  color: #999;
} */
.autoOpenFoot{
    padding: 5px 25px 20px;
    width: 320px;
    margin-top: 20px;
    background: #F4F4F4;
    border-radius: 8px;
}
.autoOpenFoot h5{
    text-align: left;
    margin-top: 5px;
}
.dayAll{
    text-align: left;
    margin-top: 10px;
}
.dayItemBox{
    text-align: left;
    margin-top: 10px;
}
.dayItem{
    float: left;
    width: 80px;
}
.dayItemBox::after {
    content: "";
    display: block;
    clear:both;
}

.bottomDiv{
    /* position: fixed;
    bottom: 38px; 
    width:100% */
    margin-top: 50px;
    text-align: center;
}
.savetBtn{
    background: #6498b5;
    color: #fff;
    font-weight: bold;
    width: 220px;
    height: 36px;
    padding: 6px 20px;
}
</style>